import React from "react";
import CheckInfo from "../../assets/img/check.png";
import Riskometer from "./Riskometer";

const CheckIconSm = ({ clipId }) => (
  <div className="check-sm">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <g clipPath={`url(#${clipId})`}>
        <path fillRule="evenodd" clipRule="evenodd" d="M7.26379 13.01C10.7286 13.01 13.5373 10.2012 13.5373 6.73646C13.5373 3.27166 10.7286 0.462891 7.26379 0.462891C3.799 0.462891 0.990234 3.27166 0.990234 6.73646C0.990234 10.2012 3.799 13.01 7.26379 13.01Z" fill="#20E083" fillOpacity="0.2" />
        <path d="M9.84777 5.21039L9.84779 5.21041C10.0169 5.37952 10.0169 5.65372 9.84779 5.82283L7.00198 8.66864C6.83287 8.83775 6.55866 8.83775 6.38956 8.66865C6.38955 8.66865 6.38955 8.66864 6.38955 8.66864M9.84777 5.21039L6.48651 8.57168L6.38955 8.66864M9.84777 5.21039C9.67863 5.04131 9.40448 5.04129 9.23536 5.21041L6.69578 7.74994L5.4117 6.46586C5.24259 6.29675 4.96838 6.29675 4.79927 6.46586C4.63017 6.63497 4.63017 6.90918 4.79927 7.07828L6.3856 8.66461M9.84777 5.21039L6.3856 8.66461M6.38955 8.66864L6.3856 8.66461M6.38955 8.66864L6.3856 8.66461" fill="white" stroke="white" strokeWidth="0.274254" />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="13.1642" height="12.7528" fill="white" transform="translate(0.600586 0.326172)" />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export default function FundCard({ fund, variant = "lg" }) {
  const isSm = variant === "sm";
  const cardClass = isSm ? "fund-card" : "fund-card-lg";
  const subtitleClass = isSm ? "fund-subtitle fund-subtitle-sm" : "fund-subtitle text-xs";
  const listClass = isSm ? "list list-sm justify-between" : "list gap-4 text-base items-center justify-between";
  const clipId = `clip-check-${fund.name.replace(/\s/g, "-")}`;

  return (
    <div className={`${cardClass} m-auto flex flex-col items-center`}>
      <div className={`flex flex-col text-leftpy-2 fund-bg min-h-fit px-5 pt-5 pb-10 lg:py-5 lg:px-8 ${isSm ? "" : "w-full"}`}>
        <p className={`fund-title font-semibold capitalize text-left ${isSm ? "text-lg" : "text-xl"}`}>{fund.name}</p>
        <div className={`${subtitleClass} text-left font-medium`}>{fund.message}</div>
        <div className="line" />
        {fund.list?.map((el, i) => (
          <div className={`flex ${listClass} mb-4`} key={i}>
            <div className={`flex items-center gap-2 ${isSm ? "justify-center" : "flex-nowrap"}`}>
              {isSm ? <CheckIconSm clipId={clipId} /> : <img src={CheckInfo} alt="rating" />}
              {el.key}
            </div>
            <div className={`flex items-center gap-2 ${isSm ? "justify-center" : "flex-nowrap"}`}>
              {el.key !== "Riskometer" && el.value}
              {el.key === "Riskometer" && <Riskometer value={el.value} />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
